/* ═══════════════════════════════════════════════════════════════
   Product page interactions.

   Deliberately small, because the buying path does not depend on it:
   every option control already submits a real variant id, so add-to-cart
   works with the script blocked. What is left is polish.

     · thumbnails    swap the hero image
     · option chips  keep the price and the readout in step
     · buy bar       slides in once the inline CTA has scrolled past
     · viewers       the simulated counter carried over from the React
                     build (the section can switch it off entirely)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Gallery ──────────────────────────────────────────────────── */

  function gallery(root) {
    var hero = root.querySelector('#gmd-pdp-hero');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gmd-thumb]'));
    if (!hero || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        // srcset would otherwise keep winning over the new src.
        hero.removeAttribute('srcset');
        hero.src = full;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ── Option chips ─────────────────────────────────────────────── */

  function options(root) {
    var readout = root.querySelector('[data-gmd-option-readout]');
    var prices = Array.prototype.slice.call(document.querySelectorAll('[data-gmd-price]'));

    root.querySelectorAll('[data-gmd-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        if (readout) readout.textContent = input.getAttribute('data-label') || '';
        var price = input.getAttribute('data-price');
        if (price) {
          prices.forEach(function (el) {
            el.textContent = price;
          });
        }
      });
    });

    var select = root.querySelector('[data-gmd-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var price = select.options[select.selectedIndex].getAttribute('data-price');
        if (!price) return;
        prices.forEach(function (el) {
          el.textContent = price;
        });
      });
    }
  }

  /* ── Sticky buy bar ───────────────────────────────────────────────
     Shown only once the inline CTA has left the top of the viewport —
     not merely "off screen", or it would also appear while the visitor
     is still above the buy button and has not seen it yet. */

  function buyBar(root) {
    var anchor = root.querySelector('[data-gmd-cta-anchor]');
    var bar = document.querySelector('[data-gmd-buybar]');
    if (!anchor || !bar) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);

    root.gmdTeardown = function () {
      io.disconnect();
    };
  }

  /* ── Simulated viewer count ───────────────────────────────────────
     Seeded 3–15 and nudged by one roughly every eight seconds. It is
     not a count of real visitors; the section's schema says so plainly
     so the shop knows what it is publishing. */

  function viewers(root) {
    var el = root.querySelector('[data-gmd-viewer-count]');
    if (!el) return;

    var n = 3 + Math.floor(Math.random() * 13);
    el.textContent = String(n);

    var timer = setInterval(function () {
      n = Math.min(15, Math.max(3, n + (Math.random() < 0.5 ? -1 : 1)));
      el.textContent = String(n);
    }, 8000);

    var previous = root.gmdTeardown;
    root.gmdTeardown = function () {
      if (previous) previous();
      clearInterval(timer);
    };
  }

  /* ── Wiring ───────────────────────────────────────────────────── */

  function init(scope) {
    (scope || document).querySelectorAll('[data-gmd-pdp]').forEach(function (root) {
      if (root.dataset.gmdReady) return;
      root.dataset.gmdReady = '1';
      gallery(root.closest('.pdp-grid') || document);
      options(root);
      buyBar(root);
      viewers(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-gmd-pdp]').forEach(function (root) {
      if (root.gmdTeardown) root.gmdTeardown();
    });
  });
})();
